import { loadOptions } from '../formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: '0', label: 'Não' },
			{ value: '1', label: 'Sim' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

